import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';
import { AuthService } from 'src/app/auth.service';
import { MessageService } from 'src/app/shared/message/message.service';
import { TitleService } from 'src/app/shared/title.service';
import { UserInfo } from 'src/app/user-info';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  standalone: false
})
export class SignInComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);
  private session = inject(TslSessionService);
  private user = inject(UserService);
  private route = inject(ActivatedRoute);
  private titleService = inject(TitleService);
  private messageService = inject(MessageService);

  signInForm = new FormGroup({
    user: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  });

  returnUrl: string;
  isLoading = false;
  isShowResendEmail = false;
  error = '';
  success = '';

  constructor() {
    this.signInForm.controls['user'].valueChanges.subscribe(() => {
      this.isShowResendEmail = false;
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Sign In');
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';
  }

  doSignIn(): void {
    if (!this.signInForm.valid) {
      return;
    }
    this.messageService.message = '';
    this.isLoading = true;
    this.error = '';
    this.success = '';
    const username = this.signInForm.get('user').value;
    const password = this.signInForm.get('password').value;
    this.auth.signIn(username, password).subscribe({
      next: (tokens) => {
        this.isLoading = false;
        this.session.construct(tokens.access_token, tokens.refresh_token);
        const userInfo = tokens.user as UserInfo;
        if (!userInfo || !userInfo.character || !userInfo.character.tribe) {
          this.router.navigate(['user/setup']);
        } else {
          this.router.navigateByUrl(this.returnUrl);
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.error = err?.error?.message;
        this.isShowResendEmail = this.error === 'ยังไม่ได้ยืนยันอีเมล';
        this.signInForm.get('password').setValue('');
      }
    });
  }

  doResendEmail(): void {
    this.success = '';
    this.error = '';
    this.isLoading = true;
    const username = this.signInForm.get('user').value;
    this.user.resendVerificationEmail(username).subscribe({
      next: () => {
        this.isLoading = false;
        this.success = 'ระบบได้ส่งอีเมลยืนยันไปยังอีเมลของคุณแล้ว';
      },
      error: (err) => {
        this.isLoading = false;
        this.error = err?.error?.message;
      }
    });
  }
}
